<script lang="ts">
  import type { Snippet } from 'svelte'
  import { buttonVariants } from '../../constants/buttons'
  import type { HTMLAnchorAttributes, HTMLButtonAttributes } from 'svelte/elements'
  import type { VariantProps } from 'class-variance-authority'
  import { route } from '@mateothegreat/svelte5-router'

  type Props = HTMLButtonAttributes & Pick<HTMLAnchorAttributes, 'href' | 'target'> & {
    children: Snippet
  } & VariantProps<typeof buttonVariants>

  let { children, size, variant, class: className, href, target, ...rest }: Props = $props()
  const anchorRest = $derived(rest as HTMLAnchorAttributes)
</script>

{#if href}
  <a
    class={[buttonVariants({ size, variant }), className]}
    {href}
    {target}
    use:route
    {...anchorRest}
  >
    {@render children?.()}
  </a>
{:else}
  <button class={[buttonVariants({ size, variant }), className]} {...rest}>
    {@render children?.()}
  </button>
{/if}
